module.exports = __webpack_public_path__ + "img/search-icon.def3f2e1.svg";